
import React, { Fragment, useContext } from 'react';
import PageSkeleton from './pageskeleton.js';
import {useGetAndStartPrimaryDatabaseStatus} from '../../api/database_status.js';
import DatabaseRestartingPage from './DatabaseRestartingPage.js';

export default function PrimaryDatabaseCheck(props) {

    const dbStatus = useGetAndStartPrimaryDatabaseStatus();
    console.log("DB Status", dbStatus.data)

    if (dbStatus.isLoading || !dbStatus.data){
        return <PageSkeleton />;
    }
    if (!dbStatus.data.status ) {
        console.log("DB Status loading or no data");
        return <DatabaseRestartingPage/>;
    }
    console.log("DB online");

    return <Fragment>{props.children}</Fragment>;
}